import axios from 'axios'
axios.defaults.baseURL = process.env.VUE_APP_RAILS_API_URL

export default {
  async login (userDetails) {
    const response = await axios.post('login', userDetails)
    return response.data
  },
  async register (userDetails) {
    const response = await axios.post('api/users', { user: userDetails })
    return response.data
  },
  async fetchRecoveryLink (recoveryLink) {
    const response = await axios.get('api/recovery_link/' + recoveryLink)
    return response.data
  },
  async resetPassword (recoveryLink) {
    const response = await axios.put('api/recovery_link/' + recoveryLink.recoveryLinkHash, { recovery_link: recoveryLink })
    return response.data
  },
  async createRecoveryLink (email) {
    const response = await axios.post('api/recovery_link', { email: email })
    return response.data
  },
  async fetchUsers (filter) {
    const response = await axios.get('api/users', { params: filter })
    return response.data
  },
  async fetchGames () {
    const response = await axios.get('api/games')
    return response.data
  },
  async fetchLiveData (gameDetails) {
    const response = await axios.get('api/games/live_data', { params: gameDetails })
    return response.data
  },
  async createSystem (systemDetails) {
    const response = await axios.post('api/systems', systemDetails)
    return response.data
  },
  async fetchSystems (params) {
    const response = await axios.get('api/systems', { params: params })
    return response.data
  },
  async fetchSystem (id) {
    const response = await axios.get('api/systems/' + id)
    return response.data
  },
  async refresh (token) {
    const response = await axios.get('session/' + token)
    return response.data
  },
  async addHorse (horseDetails) {
    const response = await axios.put('api/systems/' + horseDetails.id + '/add_horse', horseDetails)
    return response.data
  },
  async removeHorse (horseDetails) {
    const response = await axios.put('api/systems/' + horseDetails.id + '/remove_horse', horseDetails)
    return response.data
  },
  async fetchCouponFile (id) {
    const response = await axios.get('api/systems/' + id + '/coupon_file.xml')
    return response.data
  },
  async setHorseValue (details) {
    const response = await axios.put('api/systems/' + details.id + '/set_horse_value', details)
    return response.data
  },
  async setRuleValues (rule) {
    const response = await axios.put('api/systems/' + rule.id + '/update_rule', rule)
    return response.data
  },
  async lockSystem (id) {
    const response = await axios.put('api/systems/' + id + '/lock')
    return response.data
  },
  async unlockSystem (id) {
    const response = await axios.put('api/systems/' + id + '/unlock')
    return response.data
  },
  async removeGroupRule (rule) {
    const response = await axios.put('api/systems/' + rule.id + '/remove_group_rule', rule)
    return response.data
  },
  async fetchResults (id) {
    const response = await axios.get('api/systems/' + id + '/results')
    return response.data
  },
  async fetchReductionResult (id) {
    const response = await axios.get('api/systems/' + id + '/reduction')
    return response.data
  },
  async fetchGame (details) {
    const response = await axios.get('api/games/show', { params: details })
    return response.data
  },
  async updateCouponSettings (couponSettings) {
    const response = await axios.put('api/systems/' + couponSettings.id + '/coupon_settings', couponSettings)
    return response.data
  },
  async updateReserveHandling (details) {
    const response = await axios.put('api/systems/' + details.id + '/reserve_handling', details)
    return response.data
  },
  async updateReserves (reserves) {
    const response = await axios.put('api/systems/' + reserves.id + '/reserves', reserves)
    return response.data
  }
}
